<template>
  <div style="background-color: #f0f2f5" ref="review">
    <a-card>
      <a-row v-show="searchData.stage == 1">
        <a-col :span="3" class="label-right">
          <span>审核类型</span>
        </a-col>
        <a-col :span="21">
          <a-button-group>
            <a-button
              @click="
                searchData.auditbeforesend = 1
                search(1)
              "
              :type="searchData.auditbeforesend == 1 ? 'primary' : 'default'"
            >先审后发<strong class="alternate">&nbsp;{{ noRead.auditbeforesend > 0 ? '●' : '' }}</strong></a-button
            >
            <a-button
              @click="
                searchData.auditbeforesend = 2
                search(1)
              "
              :type="searchData.auditbeforesend == 2 ? 'primary' : 'default'"
            >先发后审<strong class="alternate">&nbsp;{{ noRead.sendbeforeaudit > 0 ? '●' : '' }}</strong></a-button
            >
          </a-button-group>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="3" class="label-right">
          <span>业务</span>
        </a-col>
        <a-col :span="21">
          <a-button-group>
            <template v-for="item in bussdepType">
              <a-button
                v-if="userInfo().busstypelist.includes(parseInt(item.key))"
                @click="changeBusstype(item.key)"
                :type="searchData.bussdepType == item.key ? 'primary' : 'default'"
                :key="item.key"
              >{{ item.value
              }}<strong
                class="alternate"
              >&nbsp;{{ noRead.countbybusstype[item.key] > 0 ? '●' : '' }}</strong
              ></a-button
              >
            </template>
          </a-button-group>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="3" class="label-right">
          <span>消息类型</span>
        </a-col>
        <a-col :span="21">
          <a-button-group>
            <!-- <a-button
              @click="
                searchData.msgtype = 'text'
                search(1)
              "
              :type="searchData.msgtype == 'text' ? 'primary' : 'default'"
            >文本消息<strong class="alternate">&nbsp;{{ noRead.text > 0 ? '●' : '' }}</strong></a-button
            >
            <a-button
              @click="
                searchData.msgtype = 'image'
                search(1)
              "
              :type="searchData.msgtype == 'image' ? 'primary' : 'default'"
            >图片消息<strong class="alternate">&nbsp;{{ noRead.image > 0 ? '●' : '' }}</strong></a-button
            >
            <a-button
              @click="
                searchData.msgtype = 'voice'
                search(1)
              "
              :type="searchData.msgtype == 'voice' ? 'primary' : 'default'"
            >语音消息<strong class="alternate">&nbsp;{{ noRead.voice > 0 ? '●' : '' }}</strong></a-button
            >
            <a-button
              @click="
                searchData.msgtype = 'video'
                search(1)
              "
              :type="searchData.msgtype == 'video' ? 'primary' : 'default'"
            >视频消息<strong class="alternate">&nbsp;{{ noRead.video > 0 ? '●' : '' }}</strong></a-button
            >
            <a-button
              @click="
                searchData.msgtype = 'multimedia'
                search(1)
              "
              :type="searchData.msgtype == 'multimedia' ? 'primary' : 'default'"
            >多媒体消息<strong class="alternate">&nbsp;{{ noRead.multimedia > 0 ? '●' : '' }}</strong></a-button
            > -->
            <a-button
              v-for="item in msgList"
              :key="item.msgtype"
              @click="
                searchData.msgtype = item.msgtype
                search(1)
              "
              v-show="!item.noShow || searchData.bussdepType == 4"
              :type="searchData.msgtype == item.msgtype ? 'primary' : 'default'"
            >{{ item.text }}<strong class="alternate">&nbsp;{{ noRead[item.msgtype] > 0 ? '●' : '' }}</strong></a-button
            >
          </a-button-group>
        </a-col>
      </a-row>
      <a-row>
        <a-select
          class="select"
          v-if="userInfo().role == 'ROLE_SYSTEM'"
          v-model="searchData.bussdepid"
          style="margin-right: 8px"
        >
          <a-select-option value="">--请选择事业部--</a-select-option>
          <a-select-option v-for="item in businssDept" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>
        <!-- 历史消息不支持多选内容来源 -->
        <template v-if="searchData.stage == 4">
          <a-select class="select" v-model="searchData.auditIds" style="margin-right: 8px">
            <a-select-option value="0">--内容来源--</a-select-option>
            <a-select-option v-for="item in filterChildList" :value="item.id" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
          <multiselect
            :list="labelList"
            v-if="searchData.auditIds && searchData.auditIds != 0 && searchData.msgtype != 'questionnaire'"
            ref="labelId"
            name="消息来源"
            style="margin-right: 8px"
          ></multiselect>
        </template>
        <!-- 内容来源支持多选 多选时不支持选择消息来源-->
        <template v-else>
          <multiselect
            :list="filterChildList"
            ref="auditIds"
            @change="auditIdChange"
            name="内容来源"
            style="margin-right: 8px"
          ></multiselect>

          <multiselect
            :list="labelList"
            v-if="searchData.auditIds && searchData.auditIds != 0 && searchData.msgtype != 'questionnaire'&& searchData.auditIds.split(',').length===1"
            ref="labelId"
            name="消息来源"
            style="margin-right: 8px"
          ></multiselect>
        </template>

        <!--<a-select class="select" v-model="searchData.labelId" >-->
        <!--<a-select-option value="">&#45;&#45;消息来源&#45;&#45;</a-select-option>-->
        <!--<a-select-option v-for="item in labelList" :value="item.id">{{item.label}}</a-select-option>-->
        <!--</a-select>-->

        <a-select class="select" v-model="searchData.userType" style="margin-right: 8px">
          <a-select-option value="0">--用户类型--</a-select-option>
          <a-select-option value="1">老师</a-select-option>
          <a-select-option value="2">用户</a-select-option>
        </a-select>
        <a-input v-if="searchData.msgtype == 'questionnaire'" placeholder="问卷名称" v-model="searchData.msgTitle" style="margin-right: 8px"></a-input>
        <a-select
          class="select"
          v-model="searchData.firststatus"
          v-if="searchData.stage == 2"
          style="margin-right: 8px"
        >
          <a-select-option value="0">--初审状态--</a-select-option>
          <a-select-option value="1">审核通过</a-select-option>
          <a-select-option value="2">审核拒绝</a-select-option>
        </a-select>
        <a-select class="select" v-model="searchData.secondstatus" v-if="false" style="margin-right: 8px">
          <a-select-option value="0">--复审状态--</a-select-option>
          <a-select-option value="1">审核通过</a-select-option>
          <a-select-option value="2">审核拒绝</a-select-option>
        </a-select>
        <a-input placeholder="用户昵称" v-model="searchData.nickname" style="margin-right: 8px"></a-input>
        <a-input placeholder="uid/用户账号" v-model="searchData.uid" style="margin-right: 8px"></a-input>
        <a-input
          v-if="searchData.stage == 4 && searchData.msgtype !== 'questionnaire'"
          placeholder="内容关键词"
          v-model="searchData.keyWord"
          style="margin-right: 8px"
        ></a-input>
        <a-select defaultValue="a" class="select" v-model="searchData.sort" style="margin-right: 8px">
          <a-select-option value="a">正序</a-select-option>
          <a-select-option value="d">倒序</a-select-option>
        </a-select>
        <a-date-picker
          v-if="searchData.stage == 4"
          class="select"
          :disabledDate="disabledStartDate"
          format="YYYY-MM-DD"
          v-model="startValue"
          placeholder="开始时间"
          @openChange="handleStartOpenChange"
          style="margin-right: 8px"
        />
        <a-date-picker
          v-if="searchData.stage == 4"
          class="select"
          :disabledDate="disabledEndDate"
          format="YYYY-MM-DD"
          placeholder="结束时间"
          v-model="endValue"
          :open="endOpen"
          @openChange="handleEndOpenChange"
          style="margin-right: 8px"
        />
        <a-button type="primary" @click="search(1)" style="margin-right: 8px">搜索</a-button>
        <a-button type="default" @click="reset" style="margin-right: 8px">重置</a-button>
        <a-button
          v-if="searchData.stage == 4"
          type="primary"
          icon="download"
          :loading="exportHistoryLoading"
          @click="exportHistory"
          style="margin-right: 8px"
        >导出</a-button
        >
      </a-row>
    </a-card>
    <br />
    <a-card>
      <a-table
        :scroll="{ x: true }"
        rowKey="xid"
        :rowSelection="{
          selectedRowKeys: selected,
          onChange: onSelectChange,
          getCheckboxProps: getCheckboxDisable
        }"
        v-if="
          searchData.msgtype != 'image'
        "
        :loading="loading"
        :dataSource="list"
        :pagination="false"
      >
        <a-table-column title="问卷ID" v-if="searchData.msgtype == 'questionnaire'" dataIndex="msgId" />
        <a-table-column title="用户UID" v-if="searchData.auditType == 1">
          <template slot-scope="scope">
            <a-popover
              :getPopupContainer="() => $refs.review"
              title="用户信息"
              v-if="scope.userType == 2"
              placement="right"
              trigger="hover"
              @visibleChange="visibleChange(scope)"
            >
              <template slot="content">
                <div style="text-align: center" v-if="!scope.supporterName && !scope.isFinish">
                  <img src="../../assets/loadding.gif" />
                </div>
                <template v-else>
                  <p v-if="scope.realName">客户姓名:{{ scope.realName }}</p>
                  <p>服务人员:{{ scope.supporterName }}</p>
                  <p>组织架构:{{ scope.supporterOrg }}</p>
                </template>
              </template>
              <span class="hover_cls">{{ scope.uid }}</span>
            </a-popover>
            <span v-else>{{ scope.uid }}</span>
          </template>
        </a-table-column>
        <a-table-column
          title="用户头像/昵称"
        ><template slot-scope="{ headUrl, userType, name }">
          <a-space align="center">
            <a-avatar :src="headUrl" shape="square" />
            <a-badge
              :count="filterUser(userType)"
              v-if="userType == 1"
              :numberStyle="{ backgroundColor: 'orange', marginRight: '-10px' }"
            >
              <span>{{ name }}</span>
            </a-badge>
            <span v-else>{{ name }}</span>
          </a-space>
        </template>
        </a-table-column>
        <template v-if="searchData.msgtype != 'questionnaire'">
          <a-table-column title="用户账号" dataIndex="uid" v-if="searchData.auditType == 2" />
          <a-table-column
            title="用户昵称/姓名"
            v-if="searchData.auditType == 2"
          ><template slot-scope="scope">
            <a-badge
              :count="filterUser(scope.userType)"
              v-if="scope.userType == 1"
              :numberStyle="{ backgroundColor: 'orange', marginRight: '-10px' }"
            >
              <span>{{ scope.name }}</span>
            </a-badge>
            <span v-else>{{ scope.name }}</span>
          </template>
          </a-table-column>
          <a-table-column title="内容来源" dataIndex="from" />
          <a-table-column title="业务子类型" dataIndex="bussdepSubType" />
        </template>
        <a-table-column title="封面" v-else>
          <template slot-scope="{ content }">
            <ImgView :src="content.picUrl" class="picUrl_img" />
          </template>
        </a-table-column>
        <a-table-column :title="searchData.msgtype === 'questionnaire' ? '名称及内容' : '内容'" :width="500">
          <template slot-scope="scope">
            <span v-if="scope.msgType == 'text'" v-html="filterContent(scope)"></span>
            <div v-if="scope.msgType == 'voice'">
              <playAmr v-if="/\.amr$/i.test(scope.content)" :msgId="scope.id" :src="scope.content"></playAmr>
              <!-- <audio :src="scope.content" v-else style="max-width: 300px;" preload="metadata" controls></audio> -->
              <Audio :url="scope.content" :aliyunAudit="scope.aliyunAudit" :xid="scope.xid" />
            </div>
            <div v-if="scope.msgType == 'video'">
              <video :src="scope.content" style="max-width: 300px" preload="metadata" controls />
            </div>
            <div
              v-if="scope.msgType == 'multimedia'"
              class="multimedia-content"
            >
              <div class="preview-text" v-if="isHasText(scope.content)" @click="showMultimedia(scope)">
                {{ scope | theFirstText }}
              </div>
              <div v-else>
                <template
                  v-if="
                    scope.content &&
                      scope.content[0] &&
                      scope.content[0].type == 'file' &&
                      scope.content[0].content.indexOf('.pdf') > 0 &&
                      !scope.content[1]
                  "
                >
                  <!-- 当只有一个pdf的时候直接显示出来 -->
                  <a :href="scope.content[0].content" target="_blank">{{ scope.content[0].filename }}</a>
                </template>
                <template v-else>
                  <span></span>
                  <a href="javascript:void(0);" @click="showMultimedia(scope)">点击查看</a>
                </template>
              </div>
            </div>
            <div v-if="scope.msgType == 'questionnaire' || scope.msgType == 'library'" class="preview-text" @click="showQuestion(scope.content, scope.msgType)">
              {{ scope.msgTitle || '点击查看' }}
            </div>
          </template>
        </a-table-column>
        <a-table-column :title="searchData.msgtype === 'questionnaire' ? '上传时间' : '发送时间'" dataIndex="sendTime" />
        <a-table-column
          title="初审时间"
          dataIndex="firstAuditTime"
          v-if="searchData.stage == 2 || searchData.stage == 4"
        />
        <a-table-column
          title="初审人"
          dataIndex="firstAuditorName"
          v-if="searchData.stage == 2 || searchData.stage == 4"
        >
          <span slot-scope="firstAuditorName">{{ bzNamefilter(firstAuditorName) }}</span>
        </a-table-column>

        <a-table-column
          title="初审状态"
          dataIndex="firstAuditorStatus"
          v-if="searchData.stage == 2 || searchData.stage == 4"
        ><template slot-scope="scope">
          {{ filterStatus(scope) }}
        </template>
        </a-table-column>
        <a-table-column title="复审时间" dataIndex="secondAuditTime" v-if="searchData.stage == 4" />
        <a-table-column title="复审人" dataIndex="secondAuditorName" v-if="searchData.stage == 4">
          <span slot-scope="secondAuditorName">{{ bzNamefilter(secondAuditorName) }}</span>
        </a-table-column>
        <a-table-column
          title="复审状态"
          dataIndex="secondAuditorStatus"
          v-if="searchData.stage == 4"
        ><template slot-scope="scope">
          {{ filterStatus(scope) }}
        </template>
        </a-table-column>
        <template v-if="searchData.msgtype != 'questionnaire'">
          <a-table-column title="机审类型" dataIndex="autoType"> </a-table-column>
          <a-table-column title="机审结果" dataIndex="autoResult"> </a-table-column>
          <a-table-column title="机审结果原因">
            <template slot-scope="{ msgType, autoAuditReason, content, aliyunAudit, xid }">
              <AudioReason
                :url="content"
                v-if="msgType === 'voice' && aliyunAudit === 2"
                :aliyunAudit="aliyunAudit"
                :xid="xid"
              >
                <a-button type="link">
                  {{ autoAuditReason }}
                </a-button>
              </AudioReason>
              <span v-else>{{ autoAuditReason }}</span>
            </template>
          </a-table-column>
        </template>
        <a-table-column
          title="操作"
          fixed="right"
          v-if="searchData.stage != 4"
        ><template slot-scope="scope">
          <a-space style="margin: 5px">
            <a-button
              type="link"
              size="small"
              @click="batchOp(1, scope.xid)"
              v-show="!optId.includes(scope.xid) && (scope.firstAuditorStatus != 1 || searchData.stage == 2)"
            >通过</a-button
            >
            <a-button
              type="link"
              size="small"
              @click="batchOp(2, scope.xid, scope.userType)"
              v-show="!optId.includes(scope.xid) && (scope.firstAuditorStatus != 2 || searchData.stage == 2)"
            >拒绝</a-button
            >
            <a-button
              type="link"
              size="small"
              @click="pullBacklist(scope)"
              v-show="!optId.includes(scope.xid) && searchData.stage != 4 && searchData.auditType == 1 && searchData.msgtype != 'questionnaire'"
            >拉黑</a-button
            >
            <a-button
              type="link"
              size="small"
              @click="checkDetail(scope)"
              v-show="searchData.auditType == 2"
            >查看详情</a-button
            >
          </a-space>
        </template>
        </a-table-column>
      </a-table>

      <div class="contentt" v-if="searchData.msgtype == 'image'">
        <!-- <a-checkbox style="margin-left: 5px" @change="checkAll" :checked="isChecked" v-if="searchData.stage != 4"
          >全选</a-checkbox
        > -->
        <div style="text-align: center" v-if="loading">
          <img src="../../assets/loadding.gif" />
        </div>
        <a-row>
          <a-checkbox-group v-model="selected">
            <a-row type="flex">
              <a-col v-for="(item, index) in list" class="imgList" :key="index">
                <a-card hoverable @click="onChangeImg(item.xid)">
                  <a-checkbox
                    :disabled="optId.includes(item.xid)"
                    v-if="searchData.stage != 4"
                    @change="onChangeImg"
                    :value="item.xid"
                    slot="title"
                  >{{ item.from }}
                    <div v-if="item.bussdepSubType" style="padding:10px 10px 0 10px;text-align:right;margin-right:20px">
                      <!-- 显示投资辅导班名称 -->
                      {{ item.bussdepSubType }}
                    </div>
                  </a-checkbox>

                  <template slot="actions" class="ant-card-actions">
                    <a-button
                      type="link"
                      @click="e => e.stopPropagation() & batchOp(1, item.xid)"
                      v-if="searchData.stage != 4"
                      :disabled="
                        !(!optId.includes(item.xid) && (item.firstAuditorStatus != 1 || searchData.stage == 2))
                      "
                    >通过</a-button
                    >
                    <a-button
                      type="link"
                      @click="e => e.stopPropagation() & batchOp(2, item.xid, item.userType)"
                      v-if="searchData.stage != 4"
                      :disabled="
                        !(!optId.includes(item.xid) && (item.firstAuditorStatus != 2 || searchData.stage == 2))
                      "
                    >拒绝</a-button
                    >
                    <a-button
                      type="link"
                      @click="e => e.stopPropagation() & pullBacklist(item)"
                      v-if="searchData.stage != 4 && searchData.stage !== '2'"
                      :disabled="!(!optId.includes(item.xid) && searchData.stage == 1 && searchData.auditType == 1)"
                    >拉黑</a-button
                    >
                    <a-button type="link" disabled v-if="searchData.stage == 4">{{
                      filterStatus(item.secondAuditorStatus)
                    }}</a-button>
                    <a-popover title="详细" v-if="searchData.stage == 4 || searchData.stage === '2'">
                      <template slot="content">
                        <p>用户UID:{{ item.uid }}</p>
                        <p>用户昵称/账号:{{ item.name }}</p>
                        <p>业务子类型:{{ item.from }}</p>
                        <p>内容来源:{{ filterBussdepType(item.bussdepType) }}</p>
                        <p>发送时间:{{ item.sendTime }}</p>
                        <p>初审时间:{{ item.firstAuditTime }}</p>
                        <p>初审人:{{ bzNamefilter(item.firstAuditorName) }}</p>
                        <p>初审状态:{{ filterStatus(item.firstAuditorStatus) }}</p>
                        <p v-show="searchData.stage === '4'">复审时间:{{ item.secondAuditTime }}</p>
                        <p v-show="searchData.stage === '4'">复审人:{{ bzNamefilter(item.secondAuditorName) }}</p>
                        <p v-show="searchData.stage === '4'">复审状态:{{ filterStatus(item.secondAuditorStatus) }}</p>
                        <p>机审类型:{{ item.autoType }}</p>
                        <p>机审结果:{{ item.autoResult }}</p>
                        <p>机审结果原因:{{ item.autoAuditReason }}</p>
                      </template>
                      <a-button type="link">查看详情</a-button>
                    </a-popover>
                  </template>
                  <a-card-meta :description="item.sendTime">
                    <template slot="title">
                      <a-popover
                        :getPopupContainer="() => $refs.review"
                        v-if="item.userType == 2"
                        title="用户信息"
                        placement="right"
                        trigger="hover"
                        @visibleChange="visibleChange(item)"
                      >
                        <template slot="content">
                          <div style="text-align: center" v-if="!item.supporterName && !item.isFinish">
                            <img src="../../assets/loadding.gif" />
                          </div>
                          <template v-else>
                            <p v-if="item.realName">客户姓名:{{ item.realName }}</p>
                            <p>服务人员:{{ item.supporterName }}</p>
                            <p>组织架构:{{ item.supporterOrg }}</p>
                          </template>
                        </template>
                        <span class="hover_cls hover_img">{{ `${item.name}(uid:${item.uid})` }}</span>
                      </a-popover>
                      <span v-else>{{ `${item.name}(uid:${item.uid})` }}</span>
                    </template>
                    <a-badge
                      slot="avatar"
                      :count="filterUser(item.userType)"
                      v-if="item.userType == 1"
                      :numberStyle="{ backgroundColor: 'orange', marginRight: '5px', marginTop: '5px' }"
                    >>
                      <a-avatar :src="item.headUrl" shape="square" />
                    </a-badge>
                    <a-avatar v-else slot="avatar" :src="item.headUrl" shape="square" />
                  </a-card-meta>
                  <!-- <img :src="item.content" class="cover__img" /> -->
                  <ImgView :src="item.content" class="cover__img" />
                  <p v-if="item.autoType">
                    <strong>机审({{ item.autoType }}):</strong>&nbsp; {{ item.autoResult
                    }}<a-divider type="vertical" />{{ item.autoAuditReason }}
                  </p>
                  <p v-if="item.firstAuditorName">
                    <strong>初审({{ item.firstAuditorName }}):</strong>&nbsp;
                    {{ filterStatus(item.firstAuditorStatus) }}
                  </p>
                </a-card>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-row>
      </div>
      <div style="margin-top: 10px; margin-bottom: 10px; padding-bottom: 10px; text-align: right; overflow: hidden">
        <a-pagination
          style="float: right"
          v-if="searchData.stage != 4"
          v-show="total > 0"
          :pageSizeOptions="['10', '20', '50']"
          :current="current"
          showSizeChanger
          @showSizeChange="changeLimitNum"
          :showTotal="total => `总共 ${defaultTotal} 条数据`"
          @change="changeP"
          :total="total"
          :defaultPageSize="pageSize"
        />
        <div style="float: right" v-else class="my-pagination" v-show="total > 0">
          <a-button class="my-prepage" v-if="current != 1" @click="changePrePage"><a-icon type="arrow-left" />上一页</a-button>
          <a-button class="my-nextpage" v-if="list.length === pageSize" @click="changeNextPage">下一页<a-icon type="arrow-right"/></a-button>
          <a-select class="my-limitnum" @change="changeHistoryLimitNum" :defaultValue="pageSize">
            <a-select-option :value="10">10条/页</a-select-option>
            <a-select-option :value="20">20条/页</a-select-option>
            <a-select-option :value="30">30条/页</a-select-option>
          </a-select>
        </div>
      </div>
      <a-row type="flex" justify="space-between">
        <a-col :span="12">
          <a-space> </a-space>
        </a-col>
        <a-col v-if="searchData.stage != 4">
          <a-space>
            <a-checkbox @change="checkAll" :checked="isChecked">全选</a-checkbox>
            <!-- <a-button @click="handleCheckAll">全选</a-button> -->
            <a-button type="primary" @click="batchOp(1, selected.join('&'), '', 'isAll')">批量通过</a-button>
            <a-button @click="update">刷新</a-button>
            <a-button @click="batchOp(2, selected.join('&'), '', 'isAll')">批量拒绝</a-button>
            <!-- <a-button v-if="searchData.auditType == 1" @click="batchOp(3, selected.join('&'))">批量拉黑</a-button> -->
            <a-button v-if="searchData.stage == 2" @click="batchOp(4, selected.join('&'))">与初审一致</a-button>
          </a-space>
        </a-col>
      </a-row>
    </a-card>

    <a-modal title="备注" width="400px" @ok="handleOk" @cancel="visible = false" :visible="visible">
      <a-textarea rows="4" v-model="remark" />
    </a-modal>
    <div class="mask" v-if="visible2"></div>
    <div title="拒绝原因" class="mask_con" v-if="visible2">
      <!-- <a-textarea rows="4" v-model="rejectReason" /> -->
      <div class="mask_con_header">拒绝原因
        <a-icon @click="visible2 = false" type="close" class="mask_close" />
      </div>
      <div class="mask_con_body">
        <div class="reason" v-if="searchData.stage==1">
          拒绝原因:
          <a-select
            show-search
            :filter-option="filterOption"
            class="select"
            placeholder="请选择拒绝原因"
            v-model="rejectReason2"
            :options="rejectReasonOpt"
            style="margin-bottom:10px"
            allowClear>
          </a-select>
        </div>
        <div class="reason">
          其他原因:<vue-tinymce
            ref="tinymce"
            placeholder="请输入拒绝原因"
            id="tinymce"
            v-model="rejectReason"
            :setup="tinymceSetup"
            :setting="setting" />
        </div>
        <span v-if="searchData.stage==1" style="font-size: 12px;color: rgba(0, 0, 0, 0.45);">*拒绝原因及其他原因两者必填一项</span>
      </div>
      <div class="mask_con_footer">
        <a-button @click="visible2 = false;rejectReason2=undefined;rejectReason=undefined">取消</a-button>
        <a-button type="primary" style="margin-left: 10px;" @click="handleOk2">确定</a-button>
      </div>
    </div>
    <a-modal title="用户明细" width="800px" @ok="handleOk1" @cancel="visible1 = false" :visible="visible1">
      <div class="scrollStyle" style="overflow-x: auto">
        <a-table class="searchTable" rowKey="id" :loading="loading1" :dataSource="userList" :pagination="false">
          <a-table-column title="编号" dataIndex="id" />
          <a-table-column
            title="用户头像"
            dataIndex="headUrl"
          ><template slot-scope="scope">
            <img :src="scope" width="40" alt="" />
          </template>
          </a-table-column>
          <a-table-column title="用户账号" dataIndex="uid" v-if="searchData.auditType == 2" />
          <a-table-column
            title="用户昵称/姓名"
            v-if="searchData.auditType == 2"
          ><template slot-scope="scope">
            <a-badge
              :count="filterUser(scope.userType)"
              v-if="scope.userType == 1"
              :numberStyle="{ backgroundColor: 'orange', marginRight: '-10px' }"
            >
              <span>{{ scope.name }}</span>
            </a-badge>
            <span v-else>{{ scope.name }}</span>
          </template>
          </a-table-column>
          <a-table-column title="内容来源" dataIndex="from" />
          <a-table-column title="业务子类型" dataIndex="bussdepSubType" />
          <a-table-column title="内容">
            <template slot-scope="scope">
              <span v-if="scope.msgType == 'text'" v-html="filterContent(scope)"></span>
              <div v-if="scope.msgType == 'voice'">
                <playAmr v-if="/\.amr$/i.test(scope.content)" :msgId="scope.id" :src="scope.content"></playAmr>
                <Audio
                  :url="scope.content"
                  :aliyunAudit="scope.aliyunAudit"
                  style="max-width: 300px"
                  :xid="scope.xid"
                />
              </div>
              <div v-if="scope.msgType == 'video'">
                <video :src="scope.content" style="max-width: 300px" preload="metadata" controls />
              </div>
              <div v-if="scope.msgType == 'multimedia'">
                <div class="preview-text" v-if="isHasText(scope.content)" @click="showMultimedia(scope)">
                  {{ scope | theFirstText }}
                </div>
                <div v-else>
                  <template
                    v-if="
                      scope.content &&
                        scope.content[0] &&
                        scope.content[0].type == 'file' &&
                        scope.content[0].content.indexOf('.pdf') > 0 &&
                        !scope.content[1]
                    "
                  >
                    <!-- 当只有一个pdf的时候直接显示出来 -->
                    <a :href="scope.content[0].content" target="_blank">{{ scope.content[0].filename }}</a>
                  </template>
                  <template v-else>
                    <span></span>
                    <a href="javascript:void(0);" @click="showMultimedia(scope)">点击查看</a>
                  </template>
                </div>
              </div>
            </template>
          </a-table-column>
          <a-table-column title="发送时间" dataIndex="sendTime" />
        </a-table>
      </div>
      <div style="margin-top: 10px; margin-bottom: 10px; padding-bottom: 10px; text-align: right">
        <a-pagination
          v-show="total1 > 0"
          :current="page1"
          :showTotal="total => `总共 ${total1} 条数据`"
          @change="changeP1"
          :total="total1"
          :defaultPageSize="30"
        />
      </div>
    </a-modal>
    <a-modal
      title="多媒体消息"
      width="800px"
      :bodyStyle="{ 'overflow-x': 'auto' }"
      :footer="null"
      @cancel="visibleMultimedia = false"
      :visible="visibleMultimedia"
      :destroyOnClose="true"
    >
      <RichHtml :dataSource="multimediaObj.content" :xid="multimediaObj.xid">
        <template v-slot:voice="{ item }">
          <div>
            <playAmr v-if="/\.amr$/i.test(item.content)" :msgId="scope.id" :src="item.content"></playAmr>
            <!-- <audio :src="item.content" v-else style="max-width: 300px;" preload="metadata" controls></audio> -->
            <Audio :url="item.content" :aliyunAudit="item.aliyunAudit" :xid="item.xid" />
          </div>
        </template>
        <!-- <template v-slot:image="{ item }">
          <RichBox>
            <img :src="item.content" style="max-width:200px" />
          </RichBox>
        </template> -->
        <template v-slot:video="{ item }">
          <div>
            <video :src="item.content" style="max-width: 300px" preload="metadata" controls />
          </div>
        </template>
        <template v-slot:file="{ item }">
          <div>
            <section v-if="filterFileType(item) == 'pdf'">
              <a href="javascript:void(0);" @click="previewFile(item)" v-text="item.filename"></a>
            </section>
            <a v-else :href="item.content" v-text="item.filename"></a>
          </div>
        </template>
      </RichHtml>
    </a-modal>
    <a-modal
      :title="previewFileObj.filename || ''"
      width="800px"
      :bodyStyle="{ 'overflow-x': 'auto' }"
      :footer="null"
      @cancel="
        visibleFile = false
        previewFileObj = {}
      "
      :visible="visibleFile"
    >
      <embed :src="previewFileObj.content" type="application/pdf" width="100%" height="800px" />
    </a-modal>

    <a-modal
      :title="pageTitle"
      width="60%"
      :footer="null"
      @cancel="visableQuestion = false"
      :visible="visableQuestion"
      :destroyOnClose="true"
      id="iframe_wrapper"
    >
      <iframe class="questionIframe" id="questionIframe" frameborder="0"></iframe>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { bussdepType, filterBussdepType } from '@/config/public'
import playAmr from '../../components/Amr/amrPlayer.vue'
import multiselect from '../../components/MultiSelect'
import moment from 'moment'
import Audio from '@/components/Audio'
import RichHtml from '@/components/RichHtml'
import RichBox from '@/components/RichHtml/RichBox'
import AudioReason from '@/components/Audio/AudioReason'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import ImgView from '@/components/ImgView'
import { getCustomerByUid ,getRefuseList} from '@/api/review'
import { nameFilter } from '@/utils/BzFilter.js'
import { getReviewList, auditAction, historyexport, getJobStatus, auditDetail, getCount, getLabelList } from '@/api/review'
import { depList, configmanageList } from '@/api/common'
var searchD = {
  stage: 1,
  auditType: 1,
  auditbeforesend: 1,
  bussdepType: '1',
  auditIds: '0',
  userType: '0',
  firststatus: '0',
  secondstatus: '0',
  bussdepid: '',
  nickname: '',
  labelId: '',
  uid: '',
  msgtype: 'text',
  sort: 'a',
  keyWord: '',
  startDate: '',
  endDate: '',
  msgTitle: ''
}

export default {
  name: 'FirstReview',
  components: { playAmr, multiselect, Audio, RichHtml, AudioReason, ImgView, RichBox },
  // eslint-disable-next-line vue/require-prop-types
  props: ['auditType', 'stage'],
  data() {
    return {
      pageTitle: '问卷调查',
      visableQuestion: false,
      msgList: [
        { msgtype: 'text', text: '文本消息' },
        { msgtype: 'image', text: '图片消息' },
        { msgtype: 'voice', text: '语音消息' },
        { msgtype: 'video', text: '视频消息' },
        { msgtype: 'multimedia', text: '多媒体消息' },
        { msgtype: 'library', text: '页面审核' },
        { msgtype: 'questionnaire', text: '问卷调查', noShow: true },
      ],
      // indeterminate:false,
      pageType: 1,
      bussdepType: bussdepType,
      filterBussdepType: filterBussdepType,
      childList: [],
      filterChildList: [],
      searchData: {},
      condition: {},
      total: 0,
      defaultTotal: 0,
      current: 1,
      pageSize: 20,
      loading: false,
      isChecked: false,
      selected: [],
      visible: false,
      remark: '',
      list: [],
      labelList: [],
      noRead: {
        auditbeforesend: 0,
        sendbeforeaudit: 0,
        countbybusstype: {
          1: 0,
          2: 0,
          3: 0,
          4: 0
        },
        text: 0,
        image: 0,
        voice: 0,
        video: 0
      },
      optId: [],
      chooseItem: {},
      businssDept: [],
      intel: null,
      visible1: false,
      userList: [],
      loading1: false,
      page1: 1,
      total1: 0,
      currentId: 0,
      // eslint-disable-next-line vue/no-reserved-keys
      _selectedRows: [],
      visible2: false,
      rejectReason: '',
      rejectReason2:undefined,
      isRejectMore: false, //批量拒绝还是单个拒绝
      rejectId: '', //单个拒绝消息id
      sortBtnValue: '',
      visibleMultimedia: false, //多媒体弹窗预览
      visibleFile: false, //文件弹窗预览
      multimediaObj: {},
      startValue: null,
      endValue: null,
      endOpen: false,
      exportHistoryLoading: false, //导出按钮loading
      previewFileObj: {},
      pageTinymce: '',
      setting: {
        selector: '#tinymce',
        height: 200,
        toolbar: false,
        menu: false,
        menubar: false,
        plugins: 'image paste',
        paste_data_images: true,
        branding: false,
        images_upload_handler: function(blobInfo, succFun, failFun) {
          var xhr, formData
          var file = blobInfo.blob() //转化为易于理解的file对象

          if (file.size / 1024 / 1024 > 5) {
            alert('上传图片不能超过5M大小！请删除图片重新上传！')

            // 移除显示base64的图片
            var teds = tinyMCE.editors
            var ted = null
            for (var key in teds) {
              if (key.indexOf('tinymce') >= 0) {
                ted = teds[key]
              }
            }
            var cnt = ted.getContent()
            cnt = cnt.replace(/<.*?>/gi, tag => {
              if (tag.indexOf('<img src="data:image') < 0) {
                return tag
              } else {
                return ''
              }
            })
            ted.setContent(cnt)
            return
          }
          xhr = new XMLHttpRequest()
          xhr.withCredentials = true
          xhr.open('POST', window.base_url + '/mcn/upload')
          xhr.setRequestHeader('Authorization', Vue.ls.get(ACCESS_TOKEN))
          xhr.onload = function() {
            var json
            if (xhr.status != 200) {
              failFun('HTTP Error: ' + xhr.status)
              return
            }
            json = JSON.parse(xhr.responseText)
            if (json.code == 1) {
              succFun(json.result)
            }
          }
          formData = new FormData()
          formData.append('file', file, file.name) //此处与源文档不一样
          xhr.send(formData)
        }
      },
      rejectReasonOpt:[]
    }
  },
  mounted() {
    if (window.environment == 'bz') {
      this.bussdepType = bussdepType.filter(item => item.value === '投教')
    }
    searchD.stage = this.stage
    searchD.auditType = this.auditType
    if (this.userInfo().busstypelist instanceof Array && this.userInfo().busstypelist.length > 0) {
      if (window.environment == 'bz') {
        searchD.bussdepType = '4'
      } else {
        searchD.bussdepType = this.userInfo().busstypelist[0]
      }
    }
    this.searchData = JSON.parse(JSON.stringify(searchD))
    this.getAllChildList()
    if (this.searchData.stage != 4) {
      this.search(1)
      this.updateCount()
      this.intel = setInterval(() => {
        this.updateCount()
      }, 3500)
    }
    if (this.userInfo().role == 'ROLE_SYSTEM') {
      depList().then(res => {
        if (res.code == 1) {
          if (window.environment == 'bz') {
            this.businssDept = res.result.filter(item => item.name == '博众事业部')
          } else {
            this.businssDept = res.result
          }
        }
      })
    }
    // 获取拒绝理由列表
    this.getRefuseList()
  },
  beforeDestroy: function() {
    if (this.intel) clearInterval(this.intel)
  },
  methods: {
    showQuestion (content, msgtype) {
      this.pageTitle = msgtype === 'questionnaire' ? '问卷调查' : '页面审核'
      this.visableQuestion = true
      this.$nextTick(() => {
        const iframe_wrapper = document.querySelector('#iframe_wrapper .ant-modal-body')
        const iframe = document.getElementById('questionIframe')
        iframe_wrapper.removeChild(iframe)
        const newIframe = document.createElement('iframe')
        // 兼容财富助手
        let url = content?.url || content
        if (url.indexOf('http') === -1) {
          url = `https://${url}`
        }
        url = url.replace(/^(https|http):/, location.protocol)

        newIframe.setAttribute('src', url)
        newIframe.setAttribute('frameborder', '0')
        newIframe.setAttribute('allow', 'fullscreen')
        newIframe.setAttribute('id', 'questionIframe')
        newIframe.classList.add('questionIframe')
        iframe_wrapper.appendChild(newIframe)
      })
    },
    changeBusstype (key) {
      if (this.searchData.msgtype == 'questionnaire' && key != 4) {
        this.searchData.msgtype = 'text'
      }
      this.searchData.auditIds = '0'
      this.searchData.bussdepType = key
      if (this.$refs.labelId) {
        this.$refs.labelId.checkedData = []
      }
      if (this.$refs.auditIds) {
        this.$refs.auditIds.checkedData = []
      }
      this.search(1)
    },
    visibleChange (scope) {
      if (scope.supporterName) return
      getCustomerByUid({ uid: scope.uid }).then(res => {
        const { result } = res
        setTimeout(() => {
          this.$set(scope, 'realName', result.realName)
          this.$set(scope, 'supporterName', result.supporterName)
          this.$set(scope, 'supporterOrg', result.supporterOrg?.replace('金策事业群/', ''))
          scope.isFinish = true
        }, 200)
        // scope.isFinish = true
        // if (this.stage == 4) {
        //   this.$set(scope, 'realName', result.realName)
        //   this.$set(scope, 'supporterName', result.supporterName)
        //   this.$set(scope, 'supporterOrg', result.supporterOrg)
        // } else {
        //   scope.realName = result.realName
        //   scope.supporterName = result.supporterName
        //   scope.supporterOrg = result.supporterOrg
        // }

        // this.$set(scope, 'supporterName', result.supporterName)
        // this.$set(scope, 'supporterOrg', result.supporterOrg)
      })
    },
    moment,
    ...mapGetters(['userInfo', 'token']),
    tinymceSetup(editor) {
      this.pageTinymce = editor
    },
    bzNamefilter(name) {
      return nameFilter(name)
    },
    checkDetail(scope) {
      this.visible1 = true
      this.currentId = scope.xid
      this.getList(scope.xid)
    },
    changeP1(p) {
      this.page1 = p
      this.getList(this.currentId)
    },
    getList(id) {
      this.userList = []
      this.loading = true
      auditDetail({ page: this.page1, xid: id }).then(res => {
        this.loading = false
        if (res.code == 1) {
          this.userList = res.result.list
          this.total1 = res.result.page.total
        }
      })
    },
    handleOk1() {},
    //需要输入拒绝原因的审核
    handleOk2() {
      // 2、拒绝原因及其他原因两者必填一项
      const ids = this.isRejectMore ? this.selected.join('&') : this.rejectId
      if(this.searchData.stage==1&&!this.rejectReason2&&!this.rejectReason.trim()) {
        return this.$message.error('拒绝原因及其他原因两者必填一项')
      }
      auditAction({
        xid: ids,
        action: 2,
        type: this.searchData.stage,
        blackUid: this.chooseItem.uid,
        blackNickname: this.chooseItem.name,
        auditreason: this.rejectReason2 || this.rejectReason
      }).then(res => {
        if (res.code == 1) {
          this.optId = this.optId.concat(ids.split('&'))
          if (this.isRejectMore) {
            this.selected = []
            this._selectedRows = []
          }
          this.visible2 = false
          this.$message.success('操作成功')
          this.updateCount()
          this.list = this.list.concat([])
          this.rejectReason2 = undefined
        }
      })
    },
    filterUser(type) {
      if (type == 1) {
        return '老师'
      } else if (type == 2) {
        return '用户'
      } else {
        return '未知'
      }
    },
    checkAll(e) {
      this.selected = []
      this._selectedRows = []
      var _this = this
      // this.indeterminate = false
      this.isChecked = e.target.checked
      if (this.isChecked) {
        this._selectedRows = [...this.list]
        this.list.forEach(item => {
          if (!_this.optId.includes(item.xid)) {
            _this.selected.push(item.xid)
          }
        })
      }
    },
    onChangeImg(e) {
      if (e.target) {
        if (e.target.checked) {
          const theCheckedOne = this.list.filter(item => item.xid == e.target.value)
          this._selectedRows.push(theCheckedOne[0])
        } else {
          this._selectedRows = this._selectedRows.filter(item => item.xid != e.target.value)
        }
      } else {
        const xid = e
        if (this.optId.includes(xid)) return
        const theCheckedOne = this.selected.find(item => item === xid)
        if (theCheckedOne) {
          this.selected = this.selected.filter(item => item !== xid)
        } else {
          this.selected.push(xid)
        }
      }
    },
    setSelectHrpFactRowClassName: function(record, index) {
      if (this.optId.includes(record.xid)) {
        return 'myColor'
      }
    },
    filterStatus: function(status) {
      if (status == 1) {
        return '已通过'
      } else if (status == 2) {
        return '已拒绝'
      } else {
        return '未知'
      }
    },
    filterContent: function(scope) {
      var regExp = /^(https?):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
      var textt = scope.content.replace(regExp, function(s) {
        return `<a href="${s}" target="_blank">${s}</a>`
      })
      for (const key in scope.keyWordList) {
        textt = textt.replace(scope.keyWordList[key], `<span style="color:red">${scope.keyWordList[key]}</span>`)
      }
      return textt
    },
    filterFileType(file) {
      const commonFileExtension = /\.(pdf)$/i
      if (commonFileExtension.test(file.content)) {
        return 'pdf'
      }
      return 'otherFile'
    },
    updateCount: function() {
      const params = JSON.parse(JSON.stringify({
        stage: this.searchData.stage,
        auditType: this.searchData.auditType,
        auditbeforesend: this.searchData.auditbeforesend,
        bussdepType: this.searchData.bussdepType
      }))
      getCount(params).then(res => {
        if (res.code == 1) {
          const flag = this.searchData.auditbeforesend == params.auditbeforesend && this.searchData.bussdepType == params.bussdepType
          if (res.result && res.result.constructor == Object && flag) {
            this.noRead = res.result
          }
        }
      })
    },
    handleOk: function() {
      auditAction({
        xid: this.chooseItem.xid,
        action: 3,
        type: this.searchData.stage,
        blackUid: this.chooseItem.uid,
        blackNickname: this.chooseItem.name,
        remark: this.remark
      }).then(res => {
        if (res.code == 1) {
          this.visible = false
          this.$message.success('操作成功')
        }
      })
    },
    reset: function() {
      this.searchData = JSON.parse(JSON.stringify(searchD))
      this.startValue = null
      this.endValue = null
      this.$refs.labelId&&(this.$refs.labelId.checkedData = [])
      this.$refs.auditIds&&(this.$refs.auditIds.checkedData = [])
    },
    // batchBlackList:function(){
    //   if (this.selected.length==0){
    //     this.$message.error("请选择一个用户")
    //     return
    //   } else if (this.selected.length>1){
    //     this.$message.error("仅且支持同时拉黑一个用户")
    //     return
    //   }
    //   this.chooseItem = this.list.find(item=>item.xid==this.selected[0])
    //   this.remark = ""
    //   this.visible = true
    // },
    pullBacklist: function(item) {
      this.chooseItem = item
      this.remark = ''
      this.visible = true
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this._selectedRows = selectedRows
      this.selected = selectedRowKeys
    },
    getCheckboxDisable: function(record) {
      // var _this = this
      return {
        props: {
          disabled: this.optId.includes(record.xid), // Column configuration not to be checked
          name: record.name
        }
      }
    },
    /**
     * @param userType 老师还是用户 只有在列表中拒绝时会传 1 老师 2 用户
     *  */

    batchOp (status, ids, userType = '', isAll) {
      if (!ids) {
        this.$message.error('请选择数据')
        return
      }
      //拒绝
      if (status == 2) {
        //单个拒绝
        if (userType && userType == 1) {
          this.isRejectMore = false
          this.rejectId = ids
          this.rejectReason = ''
          this.visible2 = true

          return
        } else if (!userType) {
          //没有传 表示批量拒绝 需要判断批量选择是否包含老师消息
          // const isCheckedTeacher = this._selectedRows.some(item => item.userType == 1 && !this.optId.includes(item.xid))
          const selectUserType = []
          console.log(this.optId, 'optId')
          this.selected.map(item => {
            const target = this.list.find(rowItem => rowItem.xid === item)
            if (target) {
              selectUserType.push(target.userType)
            }
          })
          const isCheckedTeacher = selectUserType.some(item => item === 1)
          if (isCheckedTeacher) {
            this.isRejectMore = true
            this.rejectReason = ''
            this.visible2 = true
            return
          }
        }
      }
      if (status == 3) {
        if (this.selected.length > 1) {
          this.$message.error('仅且支持同时拉黑一个用户')
          return
        }
        this.chooseItem = this.list.find(item => item.xid == this.selected[0])
        this.remark = ''
        this.visible = true
        return
      }
      auditAction({
        xid: ids,
        action: status,
        type: this.searchData.stage,
        blackUid: this.chooseItem.uid,
        blackNickname: this.chooseItem.name
      }).then(res => {
        if (res.code == 1) {
          this.optId = this.optId.concat(ids.split('&'))

          this.$message.success('操作成功')
          this.updateCount()
          if (isAll) {
            this.search(1)
          // } else {
          //   this.updateData(this.condition)
          }
          this.list = this.list.concat([])
          if (ids.split('&').length > 1) {
            this.selected = []
            this._selectedRows = []
            this.isChecked = false
          } else {
            const index = this._selectedRows.findIndex(item => item.xid === ids)
            if (index > -1) {
              this._selectedRows.splice(index, 1)
              this.selected.splice(index, 1)
            }
          }
        }
      })
    },
    update: function() {
      this.isChecked = false
      this.search(1)
      document.body.scrollTop = 0
    },
    changeP: function(p) {
      this.current = p
      this.condition.page = p
      this.updateData(this.condition)
    },
    changeLimitNum: function(p, page_size) {
      this.pageSize = page_size
      this.condition.pagesize = page_size
      this.updateData(this.condition)
    },
    changeHistoryLimitNum(page_size) {
      this.pageSize = page_size
      this.condition.pagesize = page_size
      this.updateData(this.condition)
    },
    changePrePage() {
      if (this.list.length) {
        this.current--
        this.condition.firstXid = this.list[0].xid
        this.condition.lastXid = ''
        this.updateData(this.condition)
        // this.search(0,true)
      }
      // else {
      //   this.current = 1
      //   this.condition.firstXid = ''
      //   this.condition.lastXid = ''
      //   this.updateData(this.condition)
      // }
    },
    changeNextPage() {
      if (this.list.length) {
        this.current++
        this.condition.lastXid = this.list[this.list.length - 1].xid
        this.condition.firstXid = ''
        this.updateData(this.condition)
        // this.search(0,true)
      }
    },
    search: function(p) {
      if (this.searchData.stage == 4) {
        if (this.searchData.auditIds == 0) {
          this.$message.error('请选择内容来源!')
          return
        }
        if (!this.startValue || !this.endValue) {
          this.$message.error('请选择开始时间和结束时间!')
          return
        }
      }
      if (this.$refs.labelId && this.searchData.auditIds != 0) {
        this.searchData.labelId = this.$refs.labelId.checkedData.join(',')
      } else {
        this.searchData.labelId = ''
      }
      var params = JSON.parse(JSON.stringify(this.searchData))
      // 非问卷去除msgTitle
      if (params.msgtype !== 'questionnaire') {
        delete params.msgTitle
      } else {
        delete params.labelId
      }
      if (params.auditIds == 0) {
        delete params.auditIds
      }
      if (params.userType == 0) {
        delete params.userType
      }
      if (params.firststatus == 0) {
        delete params.firststatus
      }
      if (params.secondstatus == 0) {
        delete params.secondstatus
      }
      //历史消息用自定义分页传id
      //其他的用页数
      if (this.searchData.stage != 4) {
        params.page = p || 1
        this.current = params.page
      } else {
        this.current = 1
        params.lastXid = ''
        params.firstXid = ''
        params.startDate = this.startValue ? this.startValue.format('YYYY-MM-DD 00:00:00') : ''
        params.endDate = this.endValue ? this.endValue.format('YYYY-MM-DD') + ' 23:59:59' : ''
        if (this.searchData.msgtype === 'questionnaire') {
          delete params.keyWord
        }
      }
      params.pagesize = this.pageSize
      this.condition = JSON.parse(JSON.stringify(params))
      this.updateData(params)
    },
    updateData(condition) {
      var searchData = condition ? condition : JSON.parse(JSON.stringify(searchD))
      this.selected = []
      this._selectedRows = []
      this.list = []
      this.optId = []
      this.loading = true
      const typeArr = [
        {
          type: 'firstAuditorName',
          code: '智能短句',
          name: '智能短句',
          result: '通过'
        },
        {
          type: 'whiteaudit',
          code: 1,
          name: '白名单',
          result: '通过'
        },
        {
          type: 'blackaudit',
          code: 2,
          name: '黑名单',
          result: '拒绝'
        },
        {
          type: 'keywordwhiteaudit',
          code: 1,
          name: '关键词白名单',
          result: '通过'
        },
        {
          type: 'keywordblackaudit',
          code: 2,
          name: '关键词黑名单',
          result: '拒绝'
        },
        {
          type: 'aliyunAudit',
          code: 3,
          name: '阿里云审核',
          result: '异常'
        },
        {
          type: 'aliyunAudit',
          code: 2,
          name: '阿里云审核',
          result: '拒绝'
        },
        {
          type: 'aliyunAudit',
          code: 1,
          name: '阿里云审核',
          result: '通过'
        }
      ]
      const aliyunAuditModeObj = {
        1: '参考值',
        2: '决定值'
      }
      getReviewList(searchData)
        .then(res => {
          if (res.code == 1) {
            if (res.result && res.result && res.result.list instanceof Array) {
              const list = res.result.list

              this.list = list.map(item => {
                let autoResult = ''
                let autoType = ''
                let autoAuditReason = item.autoAuditReason
                if (item.autoAuditReason && item.aliyunAudit === 2) {
                  const _reason = autoAuditReason.split('：{')
                  if (_reason.length > 1) {
                    const txt = '{' + _reason[1]
                    const { details, scene } = JSON.parse(txt)
                    if (details) {
                      autoAuditReason = Array.from(
                        new Set(details.filter(item => item.label !== '正常').map(item => item.label))
                      ).join('/')
                    } else {
                      autoAuditReason = scene
                    }
                  }
                }
                if (autoAuditReason && item.aliyunAuditMode) {
                  autoAuditReason += `(${aliyunAuditModeObj[item.aliyunAuditMode]})`
                }
                for (let i = 0, lenght = typeArr.length; i < lenght; i++) {
                  const { type, code, name, result } = typeArr[i]
                  if (item[type] === code) {
                    autoType = name
                    autoResult = result
                    break
                  }
                }
                return {
                  ...item,
                  autoResult,
                  autoType,
                  autoAuditReason
                }
              })
              if (this.searchData.stage != 4) {
                this.defaultTotal = res.result.page ? res.result.page.total : 0
                this.total = res.result.page
                  ? res.result.page.total > this.pageSize * 5
                    ? this.pageSize * 5
                    : res.result.page.total
                  : 0
              } else {
                this.total = res.result.page ? res.result.page.total : 0
              }
              this.sortBtnValue = this.searchData.sort == 'a' ? 'asc' : 'desc'
            }
          }
        })
        .finally(() => {
          this.loading = false
          this.isChecked = false
        })
    },
    // onChangeTime:function(date,str){
    //   this.newData.active = str
    // },
    // onChangeTime1:function(date,str){
    //   this.newData.active = str
    // },
    sortSearch(value) {
      this.sortBtnValue = value
      this.searchData.sort = this.sortBtnValue == 'desc' ? 'a' : 'd'
      this.search(1)
    },
    getAllChildList() {
      configmanageList({ auditType: this.auditType }).then(res => {
        if (res.code == 1) {
          if (res.result && res.result instanceof Array) {
            this.childList = res.result
            this.filterChildList = this.childList.filter(item => item.bussdepType == this.searchData.bussdepType)
          }
        }
      })
    },
    //展示多媒体消息
    showMultimedia(obj) {
      this.visibleMultimedia = true
      // this.multimediaObj = obj.conten
      this.multimediaObj = obj
    },
    isHasText(obj) {
      const arr = Object.values(obj)
      return arr.some(item => (item.type == 'text' || item.type == 'richtext') && item.content != '')
    },
    disabledStartDate(startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        if (startValue) {
          return startValue.valueOf() < moment('2019-10-31').valueOf()
        }
        return false
      }
      return startValue.valueOf() > endValue.valueOf() || startValue.valueOf() < moment('2019-10-31').valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        if (endValue) {
          return endValue.valueOf() < moment('2019-10-31').valueOf()
        }
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    /**
     * 导出
     * */
    async exportHistory() {
      if (this.searchData.auditIds == 0) {
        this.$message.error('请选择内容来源!')
        return
      }
      if (!this.startValue || !this.endValue) {
        this.$message.error('请选择开始时间和结束时间!')
        return
      }
      this.searchData.startDate = this.startValue ? this.startValue.format('YYYY-MM-DD 00:00:00') : ''
      this.searchData.endDate = this.endValue ? this.endValue.format('YYYY-MM-DD') + ' 23:59:59' : ''
      const {
        auditType,
        bussdepType,
        auditIds,
        msgtype,
        startDate,
        endDate,
        nickname,
        uid,
        userType,
        labelId,
        keyWord,
        msgTitle
      } = this.searchData
      const condition = {
        auditType: auditType,
        bussdepType: bussdepType,
        auditIds: auditIds,
        msgtype: msgtype,
        startDate: startDate,
        endDate: endDate,
        nickname: nickname,
        uid: uid,
        userType: userType,
        labelId: labelId,
        keyWord: keyWord
      }
      // 问卷调查导出添加问卷名称
      if (msgtype === 'questionnaire') {
        condition.msgTitle = msgTitle
        delete condition.labelId
        delete condition.keyWord
      }
      this.exportHistoryLoading = true
      const data = await this.exportJob(condition)
      if (data.code == 1) {
        this.dataFileTimeout(data.result)
      } else {
        this.exportHistoryLoading = false
      }
    },
    async dataFileTimeout(jobid) {
      const dataFile = await this.exportFile(jobid)
      if (dataFile.code == 1) {
        if (dataFile.result.status == 'create' || dataFile.result.status == 'doing') {
          setTimeout(() => {
            this.dataFileTimeout(jobid)
          }, 1000)
        } else if (dataFile.result.status == 'done') {
          this.exportHistoryLoading = false
          window.location.href = dataFile.result.data
        } else if (dataFile.result.status == 'error') {
          this.exportHistoryLoading = false
          this.$message.error(dataFile.result.status_info)
        }
      } else {
        this.exportHistoryLoading = false
      }
    },
    async exportJob(params) {
      return await historyexport(params)
    },
    async exportFile(id) {
      return await getJobStatus({ jobid: id })
    },
    //预览文件
    previewFile(obj) {
      var ua = navigator.userAgent
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid
      if (isMobile) {
        window.open(obj.content)
      } else {
        this.visibleFile = true
        this.$nextTick(() => {
          this.previewFileObj = obj
        })
      }
    },
    auditIdChange(list=[]){
      this.searchData.auditIds = list.join(',') || '0'
      this.labelList = []
      this.$refs.labelId&&(this.$refs.labelId.checkedData = [])
    },
    filterOption(input, option) {
      console.log(input, option)
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    async getRefuseList(){
      const { result } = await getRefuseList()
      this.rejectReasonOpt =  result.map(item=>{
        return {
          label:item.content,
          value:item.content,
          title:item.content
        }
      })
    }
  },
  watch: {
    'searchData.auditIds': function(value) {
      if (value) {
        //非历史消息  内容来源支持多选 多选时不支持选择消息来源
        if(this.searchData.stage!=4 && value.split(',').length !==1) return
        getLabelList({ auditId: value }).then(res => {
          if (res.code == 1 && res.result) {
            this.labelList = []
            res.result.list.forEach(item => {
              this.labelList.push({
                id: item.id,
                name: item.label
              })
            })
          }
        })
      }
    },
    'searchData.bussdepType': function(val) {
      this.filterChildList = this.childList.filter(item => item.bussdepType == val)
    }
  },
  filters: {
    theFirstText({ content: obj, msgTitle}) {
      let str = ''
      for (const key in obj) {
        if (obj[key].type == 'text' || obj[key].type == 'richtext') {
          str = obj[key].content.replace(/<[^>]+>|&[^>]+;/g, '')
        }
      }
      str = str.trim()
      if (!str) {
        str = msgTitle || '点击查看'
      }
      return str
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.ant-table-wrapper {
  .ant-table-body {
    min-width: auto !important;
  }
}
/deep/.picUrl_img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  display: block;
}
/deep/.questionIframe {
  width: 100%;
  height: 630px;
  border: 1px solid #e9e9e9;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 1000;
}
.mask_con {
  position: fixed;
  top: 50%;
  z-index: 1001;
  left: 50%;
  width: 400px;
  // height: 500px;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
  box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
  pointer-events: auto;
  .mask_close {
    font-size: 20px;
    cursor: pointer;
  }
  &_header {
    padding: 16px 24px;
    color: rgba(0,0,0,.65);
    font-weight: bolder;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    border-radius: 4px 4px 0 0;
    display: flex;
    font-size: 16px;
    align-items: center;
    justify-content: space-between;
  }
  &_body {
    padding: 2px 24px;
  }
  &_footer {
    padding: 10px 24px;
    text-align: right;
    background: transparent;
    border-top: 1px solid #e8e8e8;
    border-radius: 0 0 2px 2px;
    text-align: right;
  }
}
.hover_cls {
  cursor: pointer;
  color: #1890ff;
}
.hover_img {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.headDiv {
  padding: 20px;
  /*margin: 10px;*/
}
.ant-row {
  margin-top: 10px;
}
.label-right {
  margin-top: 5px;
  color: #333;
}
.select,
input {
  width: 200px;
  margin-top: 10px;
}
.ant-form-item {
  margin-bottom: 0;
}
.alternate {
  color: red;
  /*font-size: 13px;*/
  transform: scale(1.2);
  display: inline-block;
  animation: alternateShow 1s linear infinite alternate;
  -moz-animation: alternateShow 1s linear infinite alternate;
  /* Firefox */
  -webkit-animation: alternateShow 1s linear infinite alternate;
  /* Safari 和 Chrome */
  -o-animation: alternateShow 1s linear infinite alternate;
  /* Opera */
}
@keyframes alternateShow {
  from {
    color: #fff;
  }

  to {
    color: #ff7f00;
  }
}
.scaleimg:hover {
  transition: all 1s ease 0s;
  -webkit-transform: scale(3);
}

@-webkit-keyframes alternateShow
    /*Safari and Chrome*/ {
  from {
    color: #fff;
  }

  to {
    color: #ff7f00;
  }
}
.contentt {
  margin: 0 10px 10px;
}

.scaleImg {
  &:hover {
    transition: all 1s ease 0s;
    -webkit-transform: scale(2);
    z-index: 100;
  }
  position: relative;
  max-width: 180px;
  max-height: 120px;
}
.scaleImgDiv {
  width: 180px;
  height: 120px;
  position: absolute;
  right: 0;
  left: 0;
  top: 30px;
  bottom: 30px;
}
// .imgList {
//   margin: 5px;
//   width: 180px;
//   height: 180px;
//   text-align: center;
//   size: 12px;
//   display: inline-block;
//   position: relative;
//   box-sizing: content-box;
//   border: 1px solid #efefef;
// }
.imgList {
  width: 286px;
  margin-right: 16px;
  margin-top: 16px;
  .cover__img {
    width: 100%;
    height: 152px;
    margin: 8px auto;
    object-fit: cover;
    // transition: all 0.5s;
    &:hover {
      position: relative;
      // object-fit: contain;
      // transform: scale(1.5);
    }
  }
  p {
    margin: 0;
    overflow-wrap: anywhere;
  }
}
.checkclass {
  // position: absolute;
  // bottom: 10px;
  // right: 10px;
}
.imgBottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  left: 0;
  z-index: 1;
  background: #ffffff80;
  a {
  }
}
.preview-text {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1890ff;
  cursor: pointer;
}

.my-pagination {
  .my-prepage,
  .my-nextpage {
    margin-left: 8px;
  }
  .my-limitnum {
    margin-left: 18px;
    margin-right: 8px;
  }
}
</style>
<style lang="less">
.ant-table-column-title {
  .ant-checkbox {
    display: none;
  }
}
</style>
